import { normalizeGroup } from 'features/Integrations/utils/integrationNormalize';
import { groupsApi } from './groups.api';

export const addGroupFromEvent = (dispatch, group) => {
  const normalizedGroup = normalizeGroup(group);

  if (!normalizedGroup) return;

  dispatch(
    groupsApi.util.updateQueryData(groupsApi.endpoints.GetGroups.name, undefined, (draft) => {
      const alreadyExists = draft.some((groupInCache) => groupInCache.id === normalizedGroup.id);
      if (alreadyExists) return; // Avoid adding duplicates if the group already exists in cache

      draft.push(normalizedGroup);
    }),
  );
};

export const updateGroupFromEvent = (dispatch, group) => {
  const normalizedGroup = normalizeGroup(group);

  if (!normalizedGroup?.id) return;

  dispatch(
    groupsApi.util.updateQueryData(groupsApi.endpoints.GetGroups.name, undefined, (draft) => {
      const indexOfGroup = draft.findIndex(
        (groupInCache) => groupInCache.id === normalizedGroup.id,
      );
      if (indexOfGroup < 0) return; // Can't update if the group doesn't already exist in cache

      draft[indexOfGroup] = normalizedGroup;
    }),
  );
};

export const removeGroupFromEvent = (dispatch, groupId) => {
  if (!groupId) return;

  dispatch(
    groupsApi.util.updateQueryData(groupsApi.endpoints.GetGroups.name, undefined, (draft) =>
      draft.filter((groupInCache) => groupInCache.id !== groupId),
    ),
  );
};

// Forces a refetch of groups data if for some reason an SSE event is missed or fails to properly update the cache.
export const syncGroupsFromEvent = (dispatch) => {
  dispatch(groupsApi.util.invalidateTags(['DeviceGroups']));
};
